let coreAjaxPromise;

export function getCoreAjax() {
  if (coreAjaxPromise) return coreAjaxPromise;

  coreAjaxPromise = new Promise((resolve, reject) => {
    const req = window.require;

    if (typeof req !== 'function') {
      reject(
        new Error(
          'Moodle AMD loader (window.require) is not available on this page.'
        )
      );
      return;
    }

    req(
      ['core/ajax'],
      (Ajax) => resolve(Ajax),
      (err) => reject(err)
    );
  });

  return coreAjaxPromise;
}
